import StringUtil from "utils/StringUtil";
import messageStore from "../store/MessageStore";
import {makeAutoObservable} from "mobx";

class MessageSource {
  constructor() {
    makeAutoObservable(this);
  }
  public get(code: string, text?: string, args?: any[]) {
    let message = messageStore.getMessage(code) || (messageStore.model?.invalidSuffix || "") + (text || code) + (messageStore.model?.invalidSuffix || "");

    if (args) {
      args.forEach((arg, index) => {
        message = StringUtil.replaceAll(message, "\\{" + index + "\\}", arg);
      });
    }

    return message;
  }
}

const message = new MessageSource();

export default message;
